import { render, staticRenderFns } from "./PresentationTable.vue?vue&type=template&id=3ccce3f0&scoped=true&"
import script from "./PresentationTable.vue?vue&type=script&lang=ts&"
export * from "./PresentationTable.vue?vue&type=script&lang=ts&"
import style0 from "./PresentationTable.vue?vue&type=style&index=0&id=3ccce3f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccce3f0",
  null
  
)

export default component.exports